import styled from 'styled-components';
import { colorGray, colorPrimary, colorWhite, mediaMd, mediaSm, transitionBase } from 'theme/theme-helper-selectors';

export const DirectionsWrapper = styled.div`
    position: relative;
`;

export const Bubble5 = styled.img`
    position: absolute;
    right: 0;
    top: 260px;

    @media (${mediaMd}) {
        width: 214px;
        right: -90px;
        top: 50%;
    }
`;

export const Bubble6 = styled.img`
    position: absolute;
    left: 0;
    bottom: 0;

    @media (${mediaMd}) {
        width: 133px;
        left: -30px;
        bottom: 50px;
    }
`;

export const Container = styled.div`
    position: relative;
    padding: 0 0 215px 0;

    @media (${mediaMd}) {
        padding: 50px 0 40px 0;
    }

    @media (${mediaSm}) {
        padding: 0 0 40px 0;
    }
`;

export const TitleContainer = styled.div<{ isClosed?: boolean }>`
    margin: 0 0 40px 0;
    position: relative;
    z-index: 15;

    @media (${mediaSm}) {
        display: flex;
        flex-direction: row;
        width: ${({ isClosed }) => (isClosed ? '60%' : '100%')};
        margin: 0 0 15px 0;
    }
`;

export const Title = styled.h3`
    font-size: 48px;
    line-height: 48px;
    font-weight: 500;

    @media (${mediaSm}) {
        font-size: 32px;
        line-height: 36px;
    }
`;

export const DescriptionContainer = styled.div`
    margin: 0 0 60px 0;

    @media (${mediaSm}) {
        margin: 0 0 40px 0;
    }
`;

export const Description = styled.p`
    font-size: 24px;
    line-height: 28px;
    padding: 0 40px 0 0;
    font-weight: 500;
    position: relative;
    z-index: 15;

    @media (${mediaSm}) {
        font-size: 21px;
        line-height: 24px;
        padding: 0;
    }
`;

export const DesktopDirectionsContainer = styled.div`
    display: block;
    position: relative;
    z-index: 15;

    @media (${mediaSm}) {
        display: none;
    }
`;

export const MobileDirectionsContainer = styled.div`
    display: none;
    position: relative;
    z-index: 15;

    @media (${mediaSm}) {
        display: block;
    }
`;

export const DirectionsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 15px;

    @media (${mediaMd}) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const AccordionDirectionsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 6px;
`;

export const ArrowContainer = styled.div`
    position: absolute;
    bottom: 16px;
    right: 16px;

    svg {
        fill: transparent;
        stroke: ${colorPrimary};
        opacity: 0.3;
        transition: ${transitionBase};
    }
`;

export const DirectionCard = styled.div<{ $isMobileAccordion?: boolean }>`
    border: 1px solid ${colorPrimary};
    border-radius: 8px;
    padding: 13px 34px 13px 13px;
    transition: ${transitionBase};
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: transparent;

    &:hover {
        background: ${({ $isMobileAccordion }) => ($isMobileAccordion ? 'transparent' : `#00A88E1A`)};

        ${ArrowContainer} {
            svg {
                opacity: 1;
                transform: translateX(5px);
            }
        }
    }

    ${({ $isMobileAccordion }) =>
        $isMobileAccordion &&
        `
        border-color: ${colorPrimary};
        padding: 26px 14px;
        flex-direction: row;
        align-items: center;

        ${ArrowContainer} {
            position: static;
            svg {
                opacity: 1;
            }
        }
    `}
`;

export const DirectionCardTag = styled.span<{ $isMobileAccordion?: boolean }>`
    font-size: 12px;
    line-height: 14px;
    font-weight: 600;
    text-transform: uppercase;
    color: rgba(42, 53, 65, 0.7);
    margin: 0 0 45px 0;
    display: ${({ $isMobileAccordion }) => ($isMobileAccordion ? 'none' : 'inline-block')};
`;

export const DirectionCardName = styled.h4<{ $isMobileAccordion?: boolean }>`
    font-size: 18px;
    line-height: 21px;
    font-weight: 600;
    color: ${({ $isMobileAccordion }) => ($isMobileAccordion ? colorWhite : 'inherit')};
`;

export const FastTrack = styled.div`
    padding: 2px 7px;
    background: ${colorWhite};
    color: ${colorPrimary};
    position: absolute;
    top: 12px;
    right: 16px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    border-radius: 5px;
`;

export const ModalTitle = styled.h2`
    font-size: 32px;
    line-height: 36px;
    font-weight: 500;
    margin: 0 0 15px 0;
`;

export const ModalDisclaimer = styled.p`
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    padding: 8px 0px;
`;

export const DirectionDescription = styled.div`
    font-size: 16px;
    line-height: 18px;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;

    a {
        font-weight: 500;
    }
`;

export const DirectionTeamTitle = styled.h4`
    font-size: 18px;
    line-height: 21px;
    font-weight: 600;
    padding: 12px 0;
`;

export const ModalContainer = styled.div`
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    padding: 0 10px 0 0;

    ::-webkit-scrollbar {
        width: 9px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: ${colorGray};
        border-radius: 5px;
    }
`;
